/* eslint-disable prettier/prettier */
import { MyThunkResult } from 'store';

import { citiesAutoCompleteSuccessful, citiesAutoCompleteError, citiesAutoCompleteRequest } from 'action-creators/citiesAutocomplete';
import { CityAutoCompleteRequestResponse } from 'models/cityAutoComplete';
import { getCurrentLanguage } from 'utils/generic';
import { getLanguageWithoutRegion } from 'utils/i18n';

import { axiosConfig, netaticaCities } from '../api';

export const searchCitiesAutocomplete =
  (text: string, countryCode: string): MyThunkResult<Promise<void>> =>
  async (dispatch, getState) => {
    try {
      dispatch(citiesAutoCompleteRequest());
      const { country } = getState().i18n;
      const currentLanguage = country ? getLanguageWithoutRegion(getCurrentLanguage()) : 'ES';

      const { data } = await netaticaCities.get<CityAutoCompleteRequestResponse>('', {
        params: {
          text: text.sanitizeExceptAccents(),
          language: currentLanguage.toUpperCase(),
          countrycode: countryCode
        },
        ...axiosConfig,
      });

      dispatch(citiesAutoCompleteSuccessful(data.data));
    } catch (ex) {
      dispatch(citiesAutoCompleteError(ex));
    }
  };
